<form class="k-form" [formGroup]="form" >
    <fieldset class="k-form-fieldset">
      <legend class="k-form-legend">{{ 'TEMPLATE_EDIT_LEGEND' | i18n }}</legend>
      <kendo-formfield showHint="initial" showErrors="initial">
        <kendo-label [for]="title" [text]=" 'circ_new_label_title' | i18n "></kendo-label>
        <input kendoTextBox [formControlName]="'title'" #title required />
        <kendo-formhint>{{ 'templates_new_formhint_title' | i18n }}</kendo-formhint>
        <kendo-formerror>
          <div *ngIf="form.controls.title.errors?.required">{{ 'template_new_formerror_title' | i18n }}</div>
        </kendo-formerror>
      </kendo-formfield>
      <kendo-formfield showHint="initial" showErrors="initial">
        <kendo-label [for]="title" [text]=" 'circ_new_label_title' | i18n "></kendo-label>
        <input kendoTextBox [formControlName]="'titleCirc'" #title required />
        <kendo-formhint>{{ 'circ_new_formhint_title' | i18n }}</kendo-formhint>
        <kendo-formerror>
          <div *ngIf="form.controls.title.errors?.required">{{ 'circ_new_formerror_title' | i18n }}</div>
        </kendo-formerror>
      </kendo-formfield>
      <kendo-formfield [showErrors]="'initial'">
        <kendo-label [for]="demand" [text]="'circ_new_label_demand' | i18n"></kendo-label>
        <textarea kendoTextArea [formControlName]="'demand'" #demand required></textarea>
        <kendo-formhint>{{ 'circ_new_formhint_demand' | i18n }}</kendo-formhint>
        <kendo-formerror>
          <div *ngIf="form.controls.demand.errors?.required">{{ 'circ_new_formerror_demand' | i18n }}</div>
        </kendo-formerror>
      </kendo-formfield>
      <div class="k-form-buttons">
        <ece-btn-primary (click)="saveTemplate()" [text]=" 'circ_new_button_save' | i18n"></ece-btn-primary>
        <ece-btn (click)="cancel()" [text]=" 'circ_new_button_abort' | i18n"></ece-btn>
      </div>
    </fieldset>
  </form>

